import type { Flow } from '@/apis/generated/dialbunny';
import { FlowFromJSON, ResponseError } from '@/apis/generated/dialbunny';
import { apiStoreFactory } from '../api-store-factory';
import type { StoreEntity } from '../api-store-factory';
import { STORE } from '@/store-ids';

export type FlowStore = StoreEntity<Flow, 'id', {}>;

export const useFlowStore = apiStoreFactory<
  FlowStore['entity'],
  FlowStore['id'],
  FlowStore['filter'],
  FlowStore['createInput'],
  FlowStore['updateInput']
>(
  STORE.FLOW,
  { entityIdKey: 'id' },
  {
    read: async (flowId, { dialbunnyApi }) => {
      const result = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Flow',
        ids: flowId,
      });

      const item = result.map(FlowFromJSON).find((flow) => flow.id === flowId);

      if (!item) {
        throw new ResponseError(
          new Response(null, { status: 455 }),
          `No item with id ${flowId} in response`,
        );
      }

      return item;
    },
    bulkRead: async (ruleIds, { dialbunnyApi }) => {
      const rules = await dialbunnyApi.getModelsByKeysOfKind({
        kind: 'Flow',
        ids: ruleIds.join(','),
      });

      return rules.map(FlowFromJSON);
    },
  },
);
